"use client";

import { useState } from "react";
import { AvatarPortrait } from "./avatar-portrait";
import { cn } from "./ui";

/**
 * Avatar 卡片的视频人物展示：静音循环播放数字人样片。
 * previewVideoUrl 留给真实素材（HeyGen 每个 avatar 自带 preview 视频，
 * 从目录透传进来）；未提供或加载失败时使用人物插画，
 * 不再用无关测试视频冒充人物预览。
 */

export function AvatarVideo({
  avatarId,
  previewVideoUrl,
  className,
}: {
  avatarId: string;
  previewVideoUrl?: string;
  className?: string;
}) {
  const [failed, setFailed] = useState(false);
  const src = previewVideoUrl;

  if (failed || !src) {
    return <AvatarPortrait avatarId={avatarId} className={className} />;
  }
  return (
    <div className={cn("relative overflow-hidden", className)}>
      <video
        src={src}
        className="absolute inset-0 h-full w-full bg-black/40 object-cover"
        muted
        loop
        autoPlay
        playsInline
        preload="metadata"
        onError={() => setFailed(true)}
      />
      <span className="absolute top-2 right-2 rounded-full bg-black/55 px-2 py-0.5 text-[10px] text-white/80 backdrop-blur-sm">
        Sample
      </span>
    </div>
  );
}
